export interface ApplicationSettings {
  darkMode: boolean;
}

export enum EditModeType {
  NONE, 
  PROFILE,
  PASSWORD
}